import React from 'react';
import ErrorPage from './ErrorPage'
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      code: 500,
    };
  }

  componentDidCatch(error) {
    // Display fallback UI
    this.setState({
      hasError: true,
      code: parseInt(error.message, 10)
    });
    console.log(error); // eslint-disable-line no-console
  }

  render() {
    if (this.state.hasError) {
      // default to show HTTP 500 error when catching any Javascript error
      return <ErrorPage code={this.state.code} />;
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/Error/ErrorBoundary.jsx